import React from 'react';

import { LoginCard } from '@/components/organisms/Auth';
import { LoginLayout } from '@/components/templates/LoginLayout';
import { CmBox, CmHeading, CmText } from '@/components/uiParts';
import { routes } from '@/router';

const ResetPasswordRequested = (): JSX.Element => {
  return (
    <LoginLayout>
      <LoginCard>
        <CmHeading fontSize="2xl" mb={5} as="h1">
          {routes.ResetPasswordRequested.title}
        </CmHeading>
        <CmBox my={4}>
          <CmText>
            パスワード再設定用のURLを入力いただいたメールアドレスに送信しました。
          </CmText>
          <CmText>
            メール本文に記載された手順に従いパスワードを再設定してください。
          </CmText>
        </CmBox>
      </LoginCard>
    </LoginLayout>
  );
};

export default ResetPasswordRequested;
